import { RequestResponse } from "utils/base_api";

import { request } from "utils/api";

export async function create(
  topicSlug: string,
  parentSlug: string
): Promise<RequestResponse> {
  return request("/ignored_topics", {
    method: "POST",
    body: { topic: { slug: topicSlug, parent: { slug: parentSlug } } }
  });
}

export async function destroy(id: string): Promise<RequestResponse> {
  return request(`/ignored_topics/${id}`, { method: "DELETE" });
}
